import { parse, format } from 'date-fns'
import { path } from 'ramda'

export const getFormattedDate = (keyPath, obj) => {
  const rawDate = path(keyPath, obj)
  if (!rawDate) return null
  const parsedDate = parse(rawDate, 'd/M/yyyy', new Date())
  return format(parsedDate, 'd MMMM yyyy')
}
